import { JobApplication } from '@restworld/utility-types';
import { atom } from 'jotai';

export const workerApplicationDataLoadingAtom = atom<boolean>(true);

export const openWorkerApplicationDataLoading = atom(null, (_get, set) => {
  set(workerApplicationDataLoadingAtom, true);
});

export const closeWorkerApplicationDataLoading = atom(null, (_get, set) => {
  set(workerApplicationDataLoadingAtom, false);
});

// Separate atoms for each category
export const proposedJobApplicationsAtom = atom<JobApplication[]>([]);
export const inEvaluationJobApplicationsAtom = atom<JobApplication[]>([]);
export const activeJobApplicationsAtom = atom<JobApplication[]>([]);
export const pastJobApplicationsAtom = atom<JobApplication[]>([]);

// Setters for each category
export const setProposedJobApplicationsAtom = atom(null, (_, set, payload: JobApplication[]) => {
  set(proposedJobApplicationsAtom, payload);
});

export const setInEvaluationJobApplicationsAtom = atom(null, (_, set, payload: JobApplication[]) => {
  set(inEvaluationJobApplicationsAtom, payload);
});

export const setActiveJobApplicationsAtom = atom(null, (_, set, payload: JobApplication[]) => {
  set(activeJobApplicationsAtom, payload);
});

export const setPastJobApplicationsAtom = atom(null, (_, set, payload: JobApplication[]) => {
  set(pastJobApplicationsAtom, payload);
});

// Loading states for each category
export const proposedJobApplicationsLoadingAtom = atom<boolean>(false);
export const inEvaluationJobApplicationsLoadingAtom = atom<boolean>(false);
export const activeJobApplicationsLoadingAtom = atom<boolean>(false);
export const pastJobApplicationsLoadingAtom = atom<boolean>(false);

// Has more data flags for each category
export const proposedJobApplicationsHasMoreAtom = atom<boolean>(true);
export const inEvaluationJobApplicationsHasMoreAtom = atom<boolean>(true);
export const activeJobApplicationsHasMoreAtom = atom<boolean>(true);
export const pastJobApplicationsHasMoreAtom = atom<boolean>(true);
